import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { normalizeError } from '../../utils/errorHelpers'

const pathFor = (userId) => `/customUsers/${userId}/lsa-charge-name`

const entryOf = (state, userId) => {
  if (!state.byUserId[userId]) state.byUserId[userId] = { status: 'idle', data: null, error: null }
  return state.byUserId[userId]
}

export const getLsaChargeName = createAsyncThunk(
  'lsaChargeName/get',
  async (userId, { extra, rejectWithValue }) => {
    try {
      const response = await extra.apiRequest.get(pathFor(userId))
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  },
  { condition: (userId, { getState }) => getState().lsaChargeName?.byUserId?.[userId]?.status !== 'loading' }
)

export const setLsaChargeName = createAsyncThunk(
  'lsaChargeName/set',
  async ({ userId, key }, { extra, rejectWithValue }) => {
    try {
      const response = await extra.apiRequest.put(pathFor(userId), { key })
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const selectLsaChargeName = (userId) => (state) => state.lsaChargeName?.byUserId?.[userId]?.data ?? null

const lsaChargeNameSlice = createSlice({
  name: 'lsaChargeName',
  initialState: { byUserId: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLsaChargeName.pending, (state, action) => {
        entryOf(state, action.meta.arg).status = 'loading'
      })
      .addCase(getLsaChargeName.fulfilled, (state, action) => {
        const entry = entryOf(state, action.meta.arg)
        entry.status = 'loaded'
        entry.data = action.payload
        entry.error = null
      })
      .addCase(getLsaChargeName.rejected, (state, action) => {
        const entry = entryOf(state, action.meta.arg)
        entry.status = 'failed'
        entry.error = action.payload ?? null
      })
      .addCase(setLsaChargeName.fulfilled, (state, action) => {
        const entry = entryOf(state, action.meta.arg.userId)
        entry.data = action.payload
        entry.error = null
      })
      .addCase(setLsaChargeName.rejected, (state, action) => {
        entryOf(state, action.meta.arg.userId).error = action.payload ?? null
      })
  },
})

export default lsaChargeNameSlice.reducer
